import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, FileText, Search, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-slate-50 pt-20" data-id="element-86">
      {/* Abstract Background Elements */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-87">
        <div className="absolute -top-[20%] -right-[10%] w-[600px] h-[600px] rounded-full bg-amber-100/40 blur-3xl" data-id="element-88" />
        <div className="absolute top-[40%] -left-[10%] w-[500px] h-[500px] rounded-full bg-slate-200/40 blur-3xl" data-id="element-89" />

        {/* Floating Icons (Decorative) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 0.1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="absolute top-1/4 right-[15%] text-slate-900" data-id="element-90">
          <FileText size={64} strokeWidth={1} data-id="element-91" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 0.1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.7
      }} className="absolute bottom-1/3 left-[10%] text-slate-900" data-id="element-92">
          <Search size={48} strokeWidth={1} data-id="element-93" />
        </motion.div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center z-10" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-95">
          <span className="inline-block py-1 px-3 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold tracking-wide mb-6 border border-amber-200" data-id="element-96">
            AI-Powered Legal Discovery
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="text-5xl md:text-7xl font-serif font-bold text-slate-900 tracking-tight mb-6 max-w-4xl" data-id="element-97">
          AI-Powered Document Review That Reads Like a Lawyer
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl text-slate-600 max-w-2xl mb-10 leading-relaxed" data-id="element-98">
          Comprehensive analysis of discovery documents with Excel delivery or
          web-based review platform. Supports initial analysis and iterative
          targeted review passes.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-99">
          <Button size="lg" className="group" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-100">
            Get Started
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-101" />
          </Button>
          <Button variant="outline" size="lg" onClick={() => document.getElementById('how-it-works')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-102">
            See How It Works
          </Button>
        </motion.div>

        {/* Trust/Stats strip (Optional but good for "Premium" feel) */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="mt-20 pt-8 border-t border-slate-200 grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-103">
          <div data-id="element-104">
            <p className="text-3xl font-serif font-bold text-slate-900" data-id="element-105">
              48-72h
            </p>
            <p className="text-sm text-slate-500 uppercase tracking-wider mt-1" data-id="element-106">
              Turnaround Time
            </p>
          </div>
          <div data-id="element-107">
            <p className="text-3xl font-serif font-bold text-slate-900" data-id="element-108">100%</p>
            <p className="text-sm text-slate-500 uppercase tracking-wider mt-1" data-id="element-109">
              Document Coverage
            </p>
          </div>
          <div data-id="element-110">
            <p className="text-3xl font-serif font-bold text-slate-900" data-id="element-111">
              AES-256
            </p>
            <p className="text-sm text-slate-500 uppercase tracking-wider mt-1" data-id="element-112">
              Encryption Standard
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}